import {
    GET_OPERATING_TOURS_LIST_START,
    GET_OPERATING_TOURS_LIST_SUCCESS,
    GET_OPERATING_TOURS_LIST_ERROR,
    GET_OPERATING_TOUR_LEADS_LIST_START,
    GET_OPERATING_TOUR_LEADS_LIST_SUCCESS,
    GET_OPERATING_TOUR_LEADS_LIST_ERROR
} from "../Constants/OperatingToursConstant";
const initialState = {
    loading: false,
    operatorToursListData: [],
    operatorTourLeadsListData: [],
};
export default function OperatingToursReducer(state = { ...initialState }, action) {
    switch (action.type) {
        case GET_OPERATING_TOURS_LIST_START:
            return {
                ...state,
                loading: true,
            };
        case GET_OPERATING_TOURS_LIST_SUCCESS:
            return {
                ...state,
                operatorToursListData: action.payload,
                loading: false,
            };
        case GET_OPERATING_TOURS_LIST_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };

            case GET_OPERATING_TOUR_LEADS_LIST_START:
                return {
                    ...state,
                    loading: true,
                };
            case GET_OPERATING_TOUR_LEADS_LIST_SUCCESS:
                return {
                    ...state,
                    operatorTourLeadsListData: action.payload,
                    loading: false,
                };
            case GET_OPERATING_TOUR_LEADS_LIST_ERROR:
                return {
                    ...state,
                    loading: false,
                    message: action.error.message,
                };
        default:
            return state;
    }
}